<template>
  <el-card body-style="padding:8px 20px" shadow="never">
    <div class="flex">
      <div v-if="hasLogo" class="img-box flex-none mr10">
        <img :src="company.checkdata.ImageUrl" alt style="width:100px;height:auto" />
      </div>
      <div class="flex-auto">
        <div class="mb10">
          <span style="font-size:16px;font-weight:bold;margin-right:10px"
            >{{ company.公司名称 }}(简称:{{ company.简称 }})</span
          >
          <el-tag
            v-if="company.客户分类"
            type="warning"
            size="mini"
            class="company-tag-custom custom-warning-plain mr10"
            effect="dark"
            >客户评级：{{company.客户分类}}</el-tag
          >
          <el-tag
            v-if="company.签约 === '已签约'"
            type="danger"
            size="mini"
            class="company-tag-custom custom-danger-plain"
            effect="dark"
            >已签约</el-tag
          >
          <el-tag
            v-else-if="company.签约 === '项目拟客户'"
            type="warning"
            size="mini"
            class="company-tag-custom custom-warning-plain"
            effect="dark"
            >项目拟客户</el-tag
          >
          <el-tag
            v-else-if="company.签约 === '跟进中'"
            type="success"
            size="mini"
            class="company-tag-custom custom-success-plain"
            effect="dark"
            >跟进中</el-tag
          >
        </div>
        <div class="flex flex-wrap">
          <span class="mr20 mb10">客户经理：{{company.客户开发}}</span>
          <span class="mr20 mb10">合同签署日期：{{
            (contract.合同详情&&contract.合同详情.合同签署日期) ? dateFormat(contract.合同详情.合同签署日期, 'yyyy-mm-dd') : '--'
          }}</span>
          <span class="mr20 mb10">费率：{{(contract.合同详情&&contract.合同详情.费率) || '--'}}%</span>
          <span class="mr20 mb10">最低收费：{{(contract.合同详情&&contract.合同详情.最低金额) || '--'}}万</span>
          <span class="mr20 mb10">人选保证期：{{(contract.合同详情&&contract.合同详情.人选保证期) || '--'}}</span>
        </div>
        <div class="flex flex-wrap">
          <el-tag class="mr10 mb10" size="small" type="success">历史成单数：{{count.历史成单数||0}}单</el-tag>
          <el-tag class="mr10 mb10" size="small" type="success">面试进展中项目：{{count.面试进展中项目||0}}个</el-tag>
          <el-tag class="mr10 mb10" size="small" type="success">客户反应速度
            <el-tooltip class="item" effect="dark" content="反应速度：该客户旗下所有项目，从推荐开始到面试之间的平均天数" placement="top">
              <i class="el-icon-question" style="display: inline-flex;width: 12px;"></i>
            </el-tooltip>
            ：{{count.客户反应速度||0}}天</el-tag>
          <el-tag class="mr10 mb10" size="small" type="success">今年以来offer数：{{count.今年以来offer数||0}}个</el-tag>
          <el-tag class="mr10 mb10" size="small" type="success">回款周期
            <el-tooltip class="item" effect="dark" content="回款周期：该客户旗下所有项目，从人选到岗到回款平均时常" placement="top">
              <i class="el-icon-question" style="display: inline-flex;width: 12px;"></i>
            </el-tooltip>
            ：{{count.回款周期||0}}天</el-tag>
          <el-tag class="mr10 mb10" size="small" type="success">成单周期：{{count.成单周期||0}}天</el-tag>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'

const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
  },
  data() {
    return {
      hasLogo: false,
      contract:{},
      count:{},
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
  },
  watch: {
    company:{
      handler(newValue, oldValue) {
        if(this.company._id)this.init()
      },
      immediate:true,
    }
  },
  methods: {
    init() {
      this.hasLogo = this.company&&this.company.checkdata&&this.company.checkdata.ImageUrl
      if(this.company.companyAttachments&&this.company.companyAttachments.length>0){
        this.company.companyAttachments.sort((a,b)=>(b.createdAt||0)-(a.createdAt||0))
      }
      this.contract = (this.company.companyAttachments || []).find(v=>v.type==='合同') || {}
      this.getCount()
    },
    async getCount() {
      this.count = {}
      const res = await app.service('company').companyHistoryCount(this.company._id)
      if(res.status==='success') this.count = res.data
      else this.$message.error(res.msg)
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
<style scoped>
.company-tag {
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
</style>
